export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <rect width="36" height="36" rx="8" fill="#0E172B" />
    <path
      d="M18 6L25 10.5V18C25 23.5 18 28 18 28C18 28 11 23.5 11 18V10.5L18 6Z"
      stroke="#C5A059"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="18" cy="12" r="2" fill="#C5A059" />
    <path d="M18 15.5V19M18 19L15.2 16.2M18 19l2.8-2.8" stroke="#B22234" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 22.5h9" stroke="#C5A059" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const LogoLockup = ({ light = false, brand = "Cívica", suffix = "Ciudadanía USA" }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-9 w-9 shrink-0" />
    <span className="leading-none">
      <span className={`block font-display text-xl font-semibold tracking-tight ${light ? "text-paper" : "text-navy"}`}>{brand}</span>
      <span className={`block font-mono text-[9px] uppercase tracking-[0.22em] ${light ? "text-brass" : "text-heritage"}`}>{suffix}</span>
    </span>
  </span>
);
